import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBandsintown$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBandsintown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e4a490c01e4f37b6e111863dc3c215d55a51b5df', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f33c502883d21cfa21f412f787396f461c0fd1f4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1affabd4b2a9de5a57d13d592829f9c8a93220c5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.5 17.88V4h2.69v11.346h7.632v-.743H7.958v-2.536h9.553v5.813zM14.822 4h2.664v7.12h-2.664zm-3.56 3.74h2.663v3.381h-2.664zm-.716 0H7.882v3.381h2.664z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-bandsintown", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bandsintown"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bandsintown":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBandsintown$1);
            }
            break;
    } });
}

const CosmosIconBandsintown = CosmosIconBandsintown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBandsintown, defineCustomElement };
